import React from 'react'
import { withTheme } from '@emotion/react'
import PpcVideoAd from './PpcVideoAd.styles'

const GlobalStyles = withTheme(() => (
  <>
    <PpcVideoAd />
  </>
))

export default GlobalStyles
